import { Controller } from "@hotwired/stimulus"

export abstract class EntityFormController extends Controller<HTMLFormElement> {
  static targets = ["documentNumberInput", "dvSpan", "isTaxpayerCheckbox"]

  declare documentNumberInputTarget: HTMLInputElement;
  declare dvSpanTarget: HTMLElement;
  declare isTaxpayerCheckboxTarget: HTMLInputElement;

  abstract updateDvSpan() : void; 
}